import { PUBLIC_APP_ENV } from '$app/env/public';

// The HENI tag is deliberately not an ArticleSearchCategory: it filters on the
// article's own `isHeni` flag and is mutually exclusive with the category,
// artist and geotag filters, so it travels in its own URL param.
export const HENI_TAG_PARAM = 'heni';

export const HENI_TAG_PARAM_VALUE = '1';

export const HENI_TAG_LABEL = 'HENI';

export const HENI_NEWS_TITLE = 'HENI Feed';

// Cache-key discriminator for the server-side two-page prefetch. Not a category
// name — it only has to not collide with one in `getNewsCategoryCacheKey`.
export const HENI_FEED_CACHE_KEY = 'HeniFeed';

// The HENI feed shows a profile of its own, addressed by slug rather than by the
// name search the artist/geotag dashboards use. It is a RESERVED profile, so it
// is invisible to those searches by design — see EXCLUDE_RESERVED_PROFILES_FILTER.
export const HENI_PROFILE_SLUG = 'heni';

// Distinct from the artist_/geotag_ dashboard keys: this profile has no dashboard
// param to key on, so it gets a fixed key rather than widening getDashboardCacheKey.
export const HENI_PROFILE_CACHE_KEY = 'profile_heni';

// Each environment matches only its own `Config.Domain` host. Local dev is the
// exception: `Config.Domain` is localhost:5173 there while the feed still serves
// dev-environment urls, so local additionally accepts the dev host — otherwise
// no card would ever show the tag while developing.
//
// `undefined` in production so the dev host is compiled out of the bundle (see
// .claude/rules/production-bundle.md).
export const LOCAL_HENI_ARTICLE_HOSTNAME =
	PUBLIC_APP_ENV === 'production' ? undefined : 'dev.no-zero.net';

// The tag's black styling lives in HeniCardTag itself, alongside the other card
// tags' hard-coded palettes (blue for categories, amber for geotags).
